/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(BaseClass) {
	'use strict';

	var ActionHandler = BaseClass.extend({

		/**
		 * Menu item handler
		 */
		onSelectItem: function(context) {
			var info = context.target.activeObject;
			info.translationService.removeTranslations(info.selectedLocale);
		},

		/**
		 * Determine when we show/hide the menu item
		 */
		isItemVisible: function (options) {
			var info = options.target.activeObject;
			var defaultLanguage = info.translationService.getDefaultLanguage();

			// Can't remove the default
			return defaultLanguage !== info.selectedLocale;
		}
	});
	return ActionHandler;
});
